import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2TextWithAudioSpeakerIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 18.12 17.752",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 17.752),
    children: [/*#__PURE__*/jsx("path", {
      d: "m4.728 14.542h-3.149a1.08 1.08 0 0 1 -1.08-1.08v-11.882a1.08 1.08 0 0 1 1.08-1.08h10.8a1.08 1.08 0 0 1 1.08 1.08v3.694m-9.722-1.534h6.48m-6.48 3.241h4.51"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.181 7.624a.971.971 0 0 0 -1.017.092l-4.273 2.719h-1.942a.971.971 0 0 0 -.971.971v1.942a.971.971 0 0 0 .971.971h1.942l4.273 2.719a.971.971 0 0 0 1.554-.777v-7.77a.971.971 0 0 0 -.537-.869z"
    }), /*#__PURE__*/jsx("path", {
      d: "m17.024 13.803a2.262 2.262 0 0 0 0-2.852"
    }), /*#__PURE__*/jsx("path", {
      d: "m9.914 10.435v3.885"
    }), /*#__PURE__*/jsx("path", {
      d: "m5.051 10.463h-1.375"
    })]
  });
};

export { PM2TextWithAudioSpeakerIcon };
//# sourceMappingURL=text-with-audio-speaker.js.map
